const prefix = 'AUTH_'

export const LOGIN_REQUEST = prefix + 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = prefix + 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = prefix + 'LOGIN_FAILURE'

export const RESET_PASSWORD = prefix + 'RESET_PASSWORD'

export const LOGOUT = prefix + 'LOGOUT'
